import { useContext } from 'react';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/vdp/experiments';
import StarRatingOwnerReviewContext from '~/context/vdp/StarRatingOwnerReviewContext';
import { UserVehicleContext } from '~/context/vdp/UserVehicleContext';
import useExperimentsData from '~/hooks/common/experiments/useExperimentsData';
import useDeliveryPickupLoadedOrWillNotLoad from '~/hooks/vdp/selectors/useDeliveryPickupLoadedOrWillNotLoad';
import useGetWhyBuyDataLoaded from '~/hooks/vdp/selectors/useGetWhyBuyDataLoaded';
import useTransitChargeInfo from '~/hooks/vdp/selectors/useTransitChargeInfo';

export default function useIsVdpCoreDataLoaded(): boolean {
  const {
    vehicleAvailability: { isLoaded: vehicleAvailabilityLoaded },
    vehiclePricingInfo: { isLoaded: isPricingLoaded },
    isFavoriteReconciled
  } = useContext(UserVehicleContext);
  const isDeliveryPickupLoadedOrWillNotLoad =
    useDeliveryPickupLoadedOrWillNotLoad();
  const { experimentsLoaded } = useExperimentsData(
    browserCookieIdExperiments,
    userIdExperiments
  );
  const {
    hasOwnerReviews: { isLoaded: hasOwnerReviewsLoaded }
  } = useContext(StarRatingOwnerReviewContext);
  const { isLoaded: hasWhyBuyLoaded } = useGetWhyBuyDataLoaded();
  const transitChargeInfo = useTransitChargeInfo();

  return Boolean(
    vehicleAvailabilityLoaded &&
      isPricingLoaded &&
      isDeliveryPickupLoadedOrWillNotLoad &&
      hasOwnerReviewsLoaded &&
      hasWhyBuyLoaded &&
      isFavoriteReconciled &&
      experimentsLoaded &&
      transitChargeInfo.isLoaded
  );
}
